// src/pages/NotFound.tsx
import React from 'react';
import './NotFound.css';

const NotFound: React.FC = () => (
  <div className="notfound">
    <div className="notfound__inner">
      <div className="notfound__code">
        <span>4</span>
        <div className="notfound__zero">
          <div className="notfound__zero-inner" />
        </div>
        <span>4</span>
      </div>
      <h1 className="notfound__title">Page Not Found</h1>
      <p className="notfound__sub">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a href="/" className="notfound__btn">← Back to Home</a>
    </div>
  </div>
);

export default NotFound;